import axios from 'axios';

export default {
  fetchHistory({
    commit,
  }, params) {
    commit('setLoading', true);
    commit('setError', false);
    console.log(params);
    const { domain, domainId } = params;
    let uri = '/';

    if (domain && domainId) {
      uri += `${domain}/${domainId}/`;
    }
    uri += 'history';
    console.log(`URI: ${uri}`);

    return axios.get(uri, {
      params,
    })
      .then((history) => {
        commit('setData', history);
      })
      .catch((err) => {
        commit('setError', err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
};
